import { render, staticRenderFns } from "./ChannelNews.vue?vue&type=template&id=a3ed0da0&scoped=true"
import script from "./ChannelNews.vue?vue&type=script&lang=js"
export * from "./ChannelNews.vue?vue&type=script&lang=js"
import style0 from "./ChannelNews.vue?vue&type=style&index=0&id=a3ed0da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ed0da0",
  null
  
)

export default component.exports